<template>
  <div class="mnd-step">
    <div class="mnd-step__content">
      <Tariffline>
        <template v-slot:left>Объект страхования</template>
        <template v-slot:right>Квартира</template>
      </Tariffline>
      <Tariffline>
        <template v-slot:left>
          Максимальное страховое покрытие
          <Tippy :popperOptions="$store.state.popperOptions" class="mnd-questionmark" :hideOnClick="true" :interactive="true" trigger="click" animation="scale" placement="right" :maxWidth="392" zIndex="99">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_11211_88252)">
                <circle cx="9.9987" cy="9.9987" r="9.16667" fill="#D2D4DA" />
                <path d="M10.4204 11.666H9.06844C9.06844 11.354 9.1421 11.0463 9.28944 10.743C9.44544 10.431 9.63177 10.1537 9.84844 9.911C10.0651 9.65967 10.2818 9.417 10.4984 9.183C10.7151 8.94033 10.8971 8.69333 11.0444 8.442C11.2004 8.19067 11.2784 7.948 11.2784 7.714C11.2784 6.96 10.6934 6.583 9.52344 6.583C8.7521 6.583 7.99377 6.804 7.24844 7.246V5.894C8.0371 5.452 8.87344 5.231 9.75744 5.231C10.6414 5.231 11.3651 5.41733 11.9284 5.79C12.4918 6.16267 12.7734 6.72167 12.7734 7.467C12.7734 7.87433 12.6478 8.286 12.3964 8.702C12.1538 9.118 11.8851 9.469 11.5904 9.755C11.3044 10.041 11.0358 10.3573 10.7844 10.704C10.5418 11.0507 10.4204 11.3713 10.4204 11.666ZM10.6284 13.785C10.6284 14.0623 10.5461 14.2747 10.3814 14.422C10.2168 14.5693 10.0088 14.643 9.75744 14.643C9.5061 14.643 9.29377 14.5693 9.12044 14.422C8.95577 14.2747 8.87344 14.0623 8.87344 13.785C8.87344 13.5163 8.95577 13.3127 9.12044 13.174C9.29377 13.0267 9.5061 12.953 9.75744 12.953C10.0088 12.953 10.2168 13.0267 10.3814 13.174C10.5461 13.3127 10.6284 13.5163 10.6284 13.785Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_11211_88252">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <template #content>
              Страховые суммы являются агрегатными.
            </template>
          </Tippy>

        </template>
        <template v-slot:right>150 000 ₽</template>
      </Tariffline>
      <Tariffline>
        <template v-slot:left>Внутренняя отделка и инженерное оборудование, <br>включая возмещение расходов возникшие в результате страхового случая:</template>
        <template v-slot:right>100 000 ₽</template>
      </Tariffline>
      <Tariffline>
        <template v-slot:left>На замену дверных замков или их личинок</template>
        <template v-slot:right>5 000 ₽</template>
      </Tariffline>
      <Tariffline>
        <template v-slot:left>На уборку квартиры/дома</template>
        <template v-slot:right>15 000 ₽</template>
      </Tariffline>
      <Tariffline>
        <template v-slot:left>Домашнее имущество</template>
        <template v-slot:right>50 000 ₽</template>
      </Tariffline>
      <Tariffline>
        <template v-slot:left>Дополнительные сервисы</template>
        <template v-slot:right>
          <Tippy :popperOptions="$store.state.popperOptions" :hideOnClick="true" :interactive="true" trigger="click" animation="scale" placement="left" :maxWidth="392" zIndex="99">
            <Dotted>
              Помощь по дому (Лайт)
            </Dotted>
            <template #content>
              <p>
                Услуга «Помощь по дому» по тарифу «Лайт»&nbsp;включает 1 вызов мастера в год (электрик,&nbsp;слесарь, сантехник). <br>Лимит стоимость работ в год — 5 000 руб.
              </p>
              <p>
                Услуги доступны по истечении 14 дней<br>с даты заключения Договора.
              </p>

              <p class="mnd-mt16">
                Услуги по сервису «Помощь по дому» оказываются Сервисной организацией ООО&nbsp;«АВП&nbsp;РУС» на основании договора со&nbsp;Страховщиком. Адрес: ООО «АВП РУС» 127473, Российская Федерация, г. Москва, ул.&nbsp;Селезневская, дом 32, <br>тел.: <a class="mnd-w500" href="tel:88005552045">8 (800) 555-20-45</a> <br><a href="https://www.allianz-partners.com/ru_RU.html" class="mnd-newred" target="_blank">allianz-partners.com/ru_RU.html</a>
              </p>
            </template>
          </Tippy>
        </template>
      </Tariffline>
      <Tariffline :bold="true">
        <template v-slot:left>Стоимость программы в год</template>
        <template v-slot:right>1 000 ₽</template>
      </Tariffline>
    </div>
  </div>
</template>

<script>
import Tariffline from '../Tariffline.vue';
import { Tippy } from 'vue-tippy'
import Dotted from '../ui/Dotted.vue';

export default {
  props: {
    filledStatus: { type: Object },
    index: { type: Number, default: 1 }
  },
  mounted() {
    //eslint-disable-next-line
    this.filledStatus[this.index] = true;
  },
  components: { Tariffline, Tippy, Dotted },
}
</script>

<style lang="sass">
.mnd-step
  position: relative
  &__minititle
    font-weight: 400
    font-size: 20px
    line-height: 1.18
    margin-bottom: 14px
    color: colors.$gray3
    &:not(:first-child)
      margin-top: 36px
  &__content
    width: 100%
  &:not(.active) &__content
    position: absolute
    overflow: hidden

</style>